export function isJsonParsable(str) {
    try {
        return {
            JSONValid: true,
            value: JSON.parse(str)
        };
    } catch(e) {
        return {
            JSONValid: false,
            value: str
        };
    }
}



// WEBPACK FOOTER //
// ./src/utils/stringUtils.js